import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { paths } from '../../../common/constants/pathVariables.js';
import { I18nTextLinkEmbedded, t } from '../../../common/i18n/index.js';
import { ChangeOwnerError } from '../../../generated/api/changeOwnerError.js';
import { GenericInfoDialog } from '../../Dialogs/GenericInfoDialog.js';
import type { JSX } from 'react';
import './ChangeOwnerErrorMessage.scss';

const ChangeContractOwnerErrorDialog = (props: { header: string; body: JSX.Element; onClose: () => void }) => (
  <GenericInfoDialog onCloseDialog={props.onClose} header={props.header} body={props.body} />
);

interface ChangeOwnerErrorMessageProps {
  error: ChangeOwnerError | undefined;
  search: string;
  onClose: () => void;
}

export const ChangeOwnerErrorMessage = ({ error, search, onClose }: ChangeOwnerErrorMessageProps) => {
  switch (error?.reason) {
    case ChangeOwnerError.ReasonEnum.INVALID_EPP_AGREEMENT:
      return (
        <ChangeContractOwnerErrorDialog
          onClose={onClose}
          header={t.HJJ3('Contracting company can not be changed')}
          body={
            <div className="of-change-owner-error-message">
              <p>{t.TYVC('Contracting company can not be changed, because: ')}</p>
              <ul>
                <li className={dsClass.MARGIN_LEFT_2}>
                  {t.WKIN(
                    'The target company does not have a corresponding Elisa Palvelupäätelaite (EPP) service agreement'
                  )}
                </li>
              </ul>
              <p>
                <I18nTextLinkEmbedded
                  translation={t.UJ8H('Create a [support case], if needed.')}
                  linkTo={paths.MESSAGE_CENTER_SUPPORT_CASE_NEW + search}
                />
              </p>
            </div>
          }
        />
      );
    case ChangeOwnerError.ReasonEnum.EPP_OMA_BA:
      return (
        <ChangeContractOwnerErrorDialog
          onClose={onClose}
          header={t.HJJ3('Contracting company can not be changed')}
          body={
            <>
              <p>
                {t.L9E5(
                  'Contracting company cannot be changed, because the user of the device has an active Elisa Oma Laitelasku agreement.'
                )}
              </p>
              <p>
                <I18nTextLinkEmbedded
                  translation={t.KOO8(
                    'If you want to transfer the user to another company, you can do that on [Users] page.'
                  )}
                  linkTo={paths.COMPANY_INFO_CONTACTS}
                />
              </p>
            </>
          }
        />
      );
    case ChangeOwnerError.ReasonEnum.VOICE_VAKIO_OR_RING:
      return (
        <CL.GridRow gutter={false} className="of-change-owner-accordion--data-row">
          <CL.GridCol colWidth={12}>
            <CL.Disclaimer
              title={t.HJJ3('Contracting company can not be changed')}
              icon={<CL.Icon icon="information" size="s" />}
              visible
            >
              <span>
                <I18nTextLinkEmbedded
                  translation={t.SX7R(
                    'Contracting company can not be changed, because additional service prevents the change. Create a [support case], if needed.'
                  )}
                  linkTo={paths.MESSAGE_CENTER_SUPPORT_CASE_NEW + search}
                />
              </span>
            </CL.Disclaimer>
          </CL.GridCol>
        </CL.GridRow>
      );
    case ChangeOwnerError.ReasonEnum.COLLECTION:
      return (
        <ChangeContractOwnerErrorDialog
          onClose={onClose}
          header={t.HJJ3('Contracting company can not be changed')}
          body={
            <p>
              <I18nTextLinkEmbedded
                translation={t.W7H8('Please contact our [customer service] if needed.')}
                linkTo={paths.CONTACT_INFO}
              />
            </p>
          }
        />
      );
    default:
      return null;
  }
};
